import Backdrop from '@mui/material/Backdrop';
import CircularLoader from './CircularLoader';

export default function AiqBackdrop({ children = <CircularLoader />, sx }) {
    return (
        <div>
            <Backdrop
                sx={{
                    backgroundColor: '#a8a8a83e',
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                    ...sx,
                }}
                open={true}
            >
                {children}
            </Backdrop>
        </div>
    );
}
